import { Truck } from "@domain/CRM/truck";
import { DataAPI_Base, GetAPI_Base } from "../base";
import { Filter } from "../../../common";

const hydrateCoordinateUpdatedAt = (truck: Truck): Truck => {
	if (truck.coordinateUpdatedAt && typeof truck.coordinateUpdatedAt === "string") {
		truck.coordinateUpdatedAt = new Date(truck.coordinateUpdatedAt);
	}
	return truck;
};

class GetAPI_Trucks extends GetAPI_Base<Truck> {
	constructor() {
		super("trucks", Truck);
	}

	public async byFilter(filter?: Filter<Truck>): Promise<Truck[]> {
		const records = await super.byFilter(filter);
		records.forEach(hydrateCoordinateUpdatedAt);
		return records;
	}

	public async byId(id: string, isCompressed?: boolean): Promise<Truck> {
		const record = await super.byId(id, isCompressed);
		return hydrateCoordinateUpdatedAt(record);
	}
}

export class TrucksAPI extends DataAPI_Base<Truck> {
	get: GetAPI_Trucks;
	constructor() {
		super("trucks", Truck);
		this.get = new GetAPI_Trucks();
	}
}
